import { makeStyles, Theme } from '@material-ui/core';

const useStyles = makeStyles((theme: Theme) => ({
  popupBox: {
    padding: theme.spacing(1, 0, 1, 0),
    zIndex: 1000,
    right: 0,
    marginTop: theme.spacing(0.25),
    position: 'absolute',
    width: '200px',
  },
  popupText: {
    padding: theme.spacing(0, 1, 0, 1),
    height: '24px',
    cursor: 'pointer',
  },
}));

export default useStyles;
